import React from 'react'

const Front = ({ width = '64px', height = '64px', color }) => (
  <svg version={1.1} id="Layer_1" x="0" y="0" viewBox="0 0 960 716" xmlSpace="preserve" width={width} height={height}>
    <path
      fill="none"
      stroke={color}
      strokeWidth="9.3515"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit="10"
      d="
	M216.18,470.553c0,0-26.982-74.951-35.977-92.94c-3.792-7.585-5.996-14.99-29.981-26.982s-53.965-32.979-59.961-35.977
	s-38.975,53.965-11.992,89.942s104.932,71.953,119.922,77.949C213.182,488.542,225.174,491.54,216.18,470.553z"
    />
    <path
      fill="none"
      stroke={color}
      strokeWidth="9.3515"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit="10"
      d="
	M220.93,162.306c0,0-1.752-9.546-4.75-15.543c-2.998-5.996-31.826-3.645-37.222-3.645s-11.992,1.799-11.992,9.594
	c0,5.996,0.6,13.191,0.6,16.189s2.998,9.594,11.992,11.393c8.994,1.799,27.582,2.998,27.582,2.998"
    />
    <path
      fill="none"
      stroke={color}
      strokeWidth="9.3515"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit="10"
      d="
	M318.067,191.087c0,0-1.799-35.977,32.379-37.176s53.965,0,70.154,1.799s22.785,11.393,23.385,37.775"
    />
    <path
      fill="none"
      stroke={color}
      strokeWidth="9.3515"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit="10"
      d="
	M371.432,150.913c-6.596,0-18.588-4.797-18.588-16.189s0.6-18.588,1.199-23.385c0.6-4.797,4.797-10.793,13.791-10.793
	s23.385,0,29.98,0c7.195,0,11.393,4.197,11.992,9.594c1.286,11.571,2.398,18.588,2.398,25.783s-5.396,15.59-15.59,15.59
	C387.622,151.513,371.432,150.913,371.432,150.913z"
    />
    <path
      fill="none"
      stroke={color}
      strokeWidth="9.3515"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit="10"
      d="
	M870.136,311.656c-2.998-20.986-18.669-47.423-59.961-74.951c-35.977-23.984-62.959-59.961-62.959-59.961
	c-29.981-50.967-77.949-119.922-113.926-128.916c-35.977-8.994-152.901-8.994-152.901-8.994h-0.38c0,0-116.924,0-152.901,8.994
	s-83.946,77.949-113.926,128.916c0,0-26.982,35.977-62.959,59.961c-41.292,27.528-56.963,53.965-59.961,74.951"
    />
    <path
      fill="none"
      stroke={color}
      strokeWidth="9.3515"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit="10"
      d="
	M888.124,395.602c0,0,23.984,53.965,14.99,98.936c-8.994,44.971-17.988,50.967-17.988,65.957s10.165,29.932-29.981,47.969
	c-34.592,15.541-167.891,71.953-374.757,71.953h-0.38c-206.866,0-340.427-55.841-374.757-71.953
	c-35.023-16.438-29.981-32.979-29.981-47.969s-8.994-20.986-17.988-65.957s14.99-98.936,14.99-98.936"
    />
    <path
      fill="none"
      stroke={color}
      strokeWidth="9.3515"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit="10"
      d="
	M744.217,470.553c0,0,26.982-74.951,35.977-92.94c3.792-7.585,5.996-14.99,29.981-26.982s53.965-32.979,59.961-35.977
	s38.975,53.965,11.992,89.942s-104.932,71.953-119.922,77.949C747.215,488.542,735.223,491.54,744.217,470.553z"
    />
    <path
      fill="none"
      stroke={color}
      strokeWidth="9.3515"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit="10"
      d="
	M480.389,524.518c0,0,79.195,1.151,152.901-11.992c41.74-7.443,65.957-17.988,83.946-47.969
	c7.712-12.854,14.99-32.979,23.984-53.965c14.798-34.528,3.322-30.788-29.981-26.982c-104.932,11.992-230.85,10.146-230.85,10.146
	h-0.38c0,0-125.918,1.847-230.85-10.146c-33.302-3.806-44.778-7.546-29.981,26.982c8.994,20.986,16.272,41.111,23.984,53.965
	c17.988,29.981,42.205,40.526,83.946,47.969c73.705,13.143,152.901,11.992,152.901,11.992H480.389z"
    />
    <path
      fill="none"
      stroke={color}
      strokeWidth="9.3515"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit="10"
      d="
	M740.666,168.302c2.445,15.543-13.125,18.771-26.429,20.434c-23.984,2.998-203.868,5.996-233.848,5.996h-0.38
	c-29.981,0-209.864-2.998-233.848-5.996c-13.304-1.663-28.874-4.892-26.429-20.434"
    />
    <path
      fill="none"
      stroke={color}
      strokeWidth="9.3515"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit="10"
      d="
	M739.467,162.306c0,0,1.752-9.546,4.75-15.543s31.826-3.645,37.222-3.645s11.992,1.799,11.992,9.594c0,5.996-0.6,13.191-0.6,16.189
	s-2.998,9.594-11.992,11.393c-8.994,1.799-27.582,2.998-27.582,2.998"
    />
    <path
      fill="none"
      stroke={color}
      strokeWidth="9.3515"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit="10"
      d="
	M669.912,71.765c0,0-15.59-7.795-38.375-8.994s-94.738-4.197-151.102-4.197h-0.474c-56.363,0-128.316,2.998-151.102,4.197
	c-22.785,1.199-38.375,8.994-38.375,8.994"
    />
    <path
      fill="none"
      stroke={color}
      strokeWidth="9.3515"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit="10"
      d="
	M642.33,191.087c0,0,1.799-35.977-32.379-37.176c-34.178-1.199-53.965,0-70.154,1.799s-22.785,11.393-23.385,37.775"
    />
    <path
      fill="none"
      stroke={color}
      strokeWidth="9.3515"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit="10"
      d="
	M588.965,150.913c6.596,0,18.588-4.797,18.588-16.189s-0.6-18.588-1.199-23.385c-0.6-4.797-4.797-10.793-13.791-10.793
	c-8.994,0-23.385,0-29.981,0c-7.195,0-11.393,4.197-11.992,9.594c-1.286,11.571-2.398,18.588-2.398,25.783s5.396,15.59,15.59,15.59
	C572.775,151.513,588.965,150.913,588.965,150.913z"
    />
    <polyline
      fill="none"
      stroke={color}
      strokeWidth="18.703"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit="10"
      points="
	35.238,224.291 35.238,699.761 926.329,699.761 926.329,220.966 "
    />
    <line fill="none" stroke={color} strokeWidth="18.703" strokeLinecap="round" strokeLinejoin="round" strokeMiterlimit="10" x1="158.262" y1="19.806" x2="803.305" y2="19.806" />
  </svg>
)
export default Front
